import { useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Reads :lang from URL, syncs i18n language, redirects to /fr if invalid.
 * Wraps children of language-scoped routes.
 */
export default function LanguageProvider({ children }) {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (lang !== "fr" && lang !== "en") {
      navigate("/fr", { replace: true });
      return;
    }
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    document.documentElement.lang = lang;
    document.title = i18n.t("meta.title");
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute("content", i18n.t("meta.description"));
  }, [lang, i18n, location.pathname, navigate]);

  return children;
}
